import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Container, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { TopBarContext } from '../TopBar';
import { useSearchParams } from 'react-router-dom';

const markdownBoxSx = {
  '& p': { marginBottom: 2, fontSize: '0.875rem' },
  '& strong': { fontWeight: 600 },
  '& ul': { marginTop: 0, marginBottom: 2, paddingLeft: 3 },
  '& li': { fontSize: '0.875rem' },
  '& a': { color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }
};

function Info() {
  const [presentazioneContent, setPresentazioneContent] = React.useState<string>('');
  const [autoriContent, setAutoriContent] = React.useState<string>('');
  const [altreInformazioniContent, setAltreInformazioniContent] = React.useState<string>('');
  const [searchParams] = useSearchParams();

  const topBarCtx = React.useContext(TopBarContext);

  React.useEffect(() => {
    topBarCtx?.setTitle('Informazioni');

    fetch('/presentazione.md')
      .then(response => response.text())
      .then(text => setPresentazioneContent(text))
      .catch(err => console.error('Error loading presentazione:', err));

    fetch('/autori.md')
      .then(response => response.text())
      .then(text => setAutoriContent(text))
      .catch(err => console.error('Error loading autori:', err));

    fetch('/altre_informazioni.md')
      .then(response => response.text())
      .then(text => setAltreInformazioniContent(text))
      .catch(err => console.error('Error loading altre informazioni:', err));
  }, []);

  const section = searchParams.get('section');

  return (
    <Container maxWidth="md">
      <Box sx={{ my: 2 }}>
        <Accordion defaultExpanded={!section || section === 'presentazione'}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Presentazione</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box sx={markdownBoxSx}>
              <ReactMarkdown remarkPlugins={[remarkGfm]}>
                {presentazioneContent}
              </ReactMarkdown>
            </Box>
          </AccordionDetails>
        </Accordion>

        <Accordion defaultExpanded={section === 'autori'}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Autori</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box sx={markdownBoxSx}>
              <ReactMarkdown remarkPlugins={[remarkGfm]}>
                {autoriContent}
              </ReactMarkdown>
            </Box>
          </AccordionDetails>
        </Accordion>

        <Accordion defaultExpanded={section === 'altre-informazioni'}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Altre Informazioni</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box sx={markdownBoxSx}>
              <ReactMarkdown remarkPlugins={[remarkGfm]}>
                {altreInformazioniContent}
              </ReactMarkdown>
            </Box>
          </AccordionDetails>
        </Accordion>
      </Box>
    </Container>
  );
}

export default Info;
